/* eslint-disable prefer-arrow-callback */
import $ from 'jquery';
import App from './modules/App';
import { AppInit } from './modules/Init';
import { TextInit } from './modules/Text';

App.run(() => {
  $('.payment-details__label').on('click', function clickPaymentsLabel() {
    const self = $(this);
    self.toggleClass('--active');
    self.next().slideToggle('slow');
  });
}, 'all', '.payment-details__label');

App.run(() => {
  const form = document.querySelector('#Water-calculator');

  setTimeout(() => {
    $('.form-group .form-control, .f-group .f-control').each(App.fn.addFocused);
    $('.f-group .f-control').on('change input focus blur', App.fn.addFocused);
  }, 500);

  form.addEventListener('submit', function onSubmit(event) {
    event.preventDefault();

    const mass = this.querySelector('input').value;
    this.querySelector('.--result').innerHTML = `Wskazna dla ciebie dzienna ilość wody do wypicia to <strong>${(mass * 0.03).toFixed(1)}l</strong>.`;
  });
}, 'all', '#Water-calculator');

AppInit();
TextInit();
